var $page = [...document.querySelector("html").classList];

window.isPage = (id) => {
  return $page.includes(id);
};
window.docReady = function (callback) {
  var readyState = document.readyState;
  if (readyState == "complete" || readyState == "interactive") {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout(callback);
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
};

class Accordion {
  constructor(element) {
    this.selector = element;
    this.targets = element.querySelectorAll("[data-accordion-target]");
    this.triggers = element.querySelectorAll("[data-accordion-trigger]");
    if (this.selector) {
      this._init();
    }
  }
  _setEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        this.selector.classList.toggle("accordion__item--active");
      });
    });
  }
  _init() {
    this._setEvents();
  }
}
class Modal {
  constructor(id) {
    this.modal_selector = document.querySelector(`#${id}`);
    if (this.modal_selector) {
      this._init();
    }
  }
  _setEvents() {
    // this.modal_selector.forEach((product) => {
    //   product.addEventListener("click", (e) => {
    //     if (window.gtag) {
    //       gtag("event", "collection_to_product", {});
    //     }
    //   });
    // });
  }
  _init() {
    MicroModal.init({
      onShow: (modal) => console.info(`${modal.id} is shown`), // [1]
      onClose: (modal) => console.info(`${modal.id} is hidden`), // [2]
    });
    this._setEvents();
  }
}
class CollectionPage {
  constructor() {
    this.collection_products = document.querySelectorAll("product-item");
    this._init();
  }
  _setEvents() {
    this.collection_products.forEach((product) => {
      product.addEventListener("click", (e) => {
        if (window.gtag) {
          gtag("event", "collection_to_product", {});
        }
      });
    });
  }
  _init() {
    this._setEvents();
  }
}
class VariantSeletorByMetafields {
  constructor(product_handle) {
    this._store = {
      product_details: null,
      selected_variant_params: {},
      selected_variant: null,
    };
    this.storefront_api = axios.create({
      baseURL: `https://${Shopify.shop}/api/2023-04/graphql.json`,
      responseType: "json",
      headers: {
        "X-Shopify-Storefront-Access-Token": `99ebccca78a019b7470dc3920256b2d1`,
        "Content-Type": "application/graphql",
      },
    });
    this.storefront_api.interceptors.response.use(
      function (response) {
        if (response.data.data) {
          return response.data.data;
        }
        return response;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    this.product_handle = product_handle;
    this._init();
  }
  async getProductDetails(handle = this.product_handle) {
    let _getProductDetailsQuery = `
		{
			productByHandle(handle: "${handle}") {
				id
				title
				handle
        metafields(
          identifiers: [
            {namespace: "details", key: "new_price"}
          ]
        ) {
          id
          namespace
          key
          value
          description
        }
				variants(first: 250) {
					edges {
						node {
							id
							title
							availableForSale
							quantityAvailable
							sku
							price {
								amount
								currencyCode
							}
							metafields(
								identifiers: [
									{namespace: "details", key: "color"},
									{namespace: "details", key: "condition"},
									{namespace: "details", key: "storage"},
									{namespace: "details", key: "included_items"},
									{namespace: "details", key: "non_included_items"},
									{namespace: "details", key: "variant_images"}
								]
							) {
								id
								namespace
								key
								value
								description
							}
						}
					}
				}
			}
		  }
		`;
    let rawProductDetails = await this.storefront_api.post(
      "/",
      _getProductDetailsQuery
    );
    let formattedProductDetails = (raw_product_details) => {
      let _productDetails = raw_product_details;

      // Format Product Variants
      let _productVariants = _productDetails.variants.edges
        .filter((v) => {
          let _variant = v.node;
          return _variant.availableForSale;
        })
        .map((v) => {
          let _variant = v.node;
          let _variantDetails = {};
          _variant.metafields
            .filter((m) => m && m.namespace && m.namespace === "details")
            .sort((a, b) => {
              if (a.key === "condition") {
                return -1;
              }
              return 0;
            })
            .forEach((detail) => {
              let detail_key = detail.key;
              // detail_key = detail.description;
              _variantDetails[detail_key] = detail.value;
            });
          return {
            ..._variant,
            metafields: _variant.metafields.filter((m) => m),
            id: +_variant.id.split("/").pop(),
            price: +_variant.price.amount,
            details: _variantDetails,
          };
        });

      // Format Product Variants Params
      let _productVariantParams = {};
      _productVariants.map((v) => {
        let variant_options = Object.keys(v.details);
        variant_options.forEach((option) => {
          if (!["condition", "color", "storage"].includes(option)) {
            return;
          }
          if (!_productVariantParams[option]) {
            _productVariantParams[option] = [];
          }
          if (!_productVariantParams[option].includes(v.details[option])) {
            _productVariantParams[option].push(v.details[option]);
          }
        });
        return {};
      });

      return {
        ..._productDetails,
        id: +_productDetails.id.split("/").pop(),
        variants: _productVariants,
        variant_parameters: _productVariantParams,
      };
    };

    window.TT._helpers.triggerEvent(
      "variant_selector.get_product_details:success",
      formattedProductDetails(rawProductDetails.productByHandle)
    );

    return true;
  }
  async buildVariantSelector(handle = this.product_handle) {
    if (
      this._store.product_details &&
      this._store.product_details.variant_parameters
    ) {
      let product_details = this._store.product_details;
      let variantSelectorParams =
        this._store.product_details.variant_parameters;
      let $target = document.querySelector(
        `product-variant_selector-metafield[data-product-id="${product_details.id}"]`
      );
      let getTranslatedParam = (param)=>{
        switch (param) {
          case 'condition':
            return 'Estado de conservação'
            break;
          case 'color':
            return 'Cor'
            break;
          case 'storage':
            return 'Armazenamento'
            break;
          default:
            return param
            break;
        }
      };
      let _variantSelectorParamsTemplate = `
	  		<form class="product-form__variant-selector variant-selector" data-variant-selector-form>
			  ${Object.keys(variantSelectorParams)
          .map((param) => {
            return `
					  <div class="variant-selector__param">
						  <b class="variant-selector__param__title">
                ${getTranslatedParam(param)}:
                ${param === 'condition' ?
                `
                  <small data-aside-modal="condition-details">
                    Saiba mais
                  </small>
                `: ``}
              </b>
						  <div class="variant-selector__param__options">
							  ${variantSelectorParams[param]
                  .map((option) => {
                    return `
										<input class="variant-selector__param__option__input" type="radio" data-variant-param-input="${param}" data-variant-param-input-option="${option}" id="${
                      product_details.id
                    }.${param}.${option}" name="${param}" value="${option}">
										<label class="variant-selector__param__option" data-variant-param="${param}" data-variant-param-option="${option}" for="${
                      product_details.id
                    }.${param}.${option}">
											<div class="variant-selector__param__option--inner">
												<span class="variant-selector__param__option__title">${option}</span>
												${
                          param === "condition"
                            ? `<small class="variant-selector__param__option__price"></small>`
                            : ``
                        }
											</div>
										</label>
									`;
                  })
                  .join("")}
						  	</div>
					  	</div>
				  	`;
          })
          .join("")}
			</form>
		`;
      $target.innerHTML = _variantSelectorParamsTemplate;
      window.TT._helpers.triggerEvent(
        "variant_selector:created",
      );
    }
  }
  async resetVariantParams (conditionHasChanged, colorHasChanged, _form) {
    let $form = _form;
    if(!$form){
      return
    }
    $form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      let paramsToPrevent = ["condition"]
      if(conditionHasChanged){
        paramsToPrevent = ["condition"]
      }
      if(colorHasChanged){
        paramsToPrevent = ["condition", "color"]
      }
      if (paramsToPrevent.includes(radio.getAttribute("name"))) {
        return;
      }
      radio.checked = false;
    });
    return;
  }
  setVariantSelectorEvents() {
    document
      .querySelectorAll("[data-variant-selector-form]")
      .forEach((form) => {
        form.addEventListener(`change`, async (e) => {
          let formData = new FormData(e.currentTarget);
          let selectedVariantParams = Object.fromEntries(formData);
          let conditionHasChanged = (old_condition, curr_condition) => {
            if (!old_condition || old_condition === curr_condition) {
              return false;
            }
            return true;
          };
          let colorHasChanged = (old_color, curr_color) => {
            if (!old_color || old_color === curr_color) {
              return false;
            }
            return true;
          };
          let $conditionHasChanged = conditionHasChanged(this._store.selected_variant_params.condition,selectedVariantParams.condition)
          let $colorHasChanged = colorHasChanged(this._store.selected_variant_params.color,selectedVariantParams.color)
          if (
            $conditionHasChanged ||
            $colorHasChanged
          ) {
            let setNewVariantParams = () => {
              if($conditionHasChanged){
                selectedVariantParams = {
                  condition: selectedVariantParams.condition
                };
                return
              }
              if($colorHasChanged){
                selectedVariantParams = {
                  condition: selectedVariantParams.condition,
                  color: selectedVariantParams.color
                };
                return
              }
              selectedVariantParams = {
                condition: selectedVariantParams.condition,
                color: selectedVariantParams.color,
                storage: selectedVariantParams.storage,
              };
              return

            }
            setNewVariantParams();

            await this.resetVariantParams(
              $conditionHasChanged,
              $colorHasChanged,
              form
            );
          }

          this._store.selected_variant_params = selectedVariantParams;
          window.TT._helpers.triggerEvent(
            "variant_selector.selected_variant_params:updated",
            {
              variant_selector_form: e.currentTarget,
              selected_variant_params: this._store.selected_variant_params,
            }
          );
        });
        form.addEventListener(
          "tt.variant_selector.selected_variant_params:reset",
          async (e) => {
            let selectedVariantParams = this._store.selected_variant_params
            let setNewVariantParams = () => {
              selectedVariantParams = {
                condition: selectedVariantParams.condition
              };
              return
            }
            setNewVariantParams();
            await this.resetVariantParams(
              true,
              false,
              form
            );

            this._store.selected_variant_params = selectedVariantParams;
            window.TT._helpers.triggerEvent(
              "variant_selector.selected_variant_params:updated",
              {
                variant_selector_form: e.target,
                selected_variant_params: this._store.selected_variant_params,
              }
            );
          }
        )
      });

    document.addEventListener(
      "tt.variant_selector.selected_variant_params:updated",
      (e) => {
        let $form  = e.detail.variant_selector_form
        let selected_variant = this.findVariantByParams();
        if (selected_variant) {
          let current_variant = this?.selected_variant?.id
          let new_variant = selected_variant.id
          if(current_variant !== new_variant){
            this.selected_variant = selected_variant;
            window.TT._helpers.triggerEvent(
              "variant_selector.selected_variant:updated",
              selected_variant
            );
          }
        } else {
          window.TT._helpers.triggerEvent(
            "variant_selector.selected_variant_params:reset",
            $form,
            $form
          );
          return
        }

        let variantParamsAvailability = this.getAlternativeParams();
        variantParamsAvailability.forEach((variantParam) => {
          let $form = e.detail.variant_selector_form;
          let variant_param_key = variantParam.key;
          let variant_param_value = variantParam.value;
          let $variant_param_option = $form.querySelector(
            `[data-variant-param='${variant_param_key}'][data-variant-param-option='${variant_param_value}']`
          );
          let hasColorSelected = this._store.selected_variant_params.color !== undefined
          if (
            $variant_param_option.querySelector(
              ".variant-selector__param__option__price"
            ) &&
            variantParam.result
          ) {
            $variant_param_option.querySelector(
              ".variant-selector__param__option__price"
            ).innerHTML = `R$${(variantParam.result.price * window.TT.general_infos.discount_factor).toFixed(2)}`;
          }
          if (
            ["condition"].includes(variant_param_key) ||
            (["color"].includes(variant_param_key) && hasColorSelected)
          ) {
            return;
          }
          $form.querySelector(
            `[data-variant-param='${variant_param_key}'][data-variant-param-option='${variant_param_value}']`
          );
          if (!variantParam.available) {
            $variant_param_option.classList.add(
              "variant-selector__param__option--disabled"
            );
          } else {
            $variant_param_option.classList.remove(
              "variant-selector__param__option--disabled"
            );
          }
        });
      }
    );
    document.addEventListener(
      "tt.variant_selector.selected_variant:updated",
      (e) => {
        let selected_variant = this.selected_variant;
        let updateVariantMetafieldInfo = (info_key, elements) => {
          let variant_info = selected_variant.metafields.find(
            (m) => m.key === info_key
          );
          if (variant_info) {
            document.querySelectorAll(elements).forEach((el) => {
              el.innerHTML = `${variant_info.value}`;
            });
          }
        };
        let updateVariantPrice = () => {
          let elements = "[data-product-price-list]";

          let variant_info = selected_variant;
          if (variant_info) {
            document.querySelectorAll(elements).forEach((el) => {
              el.innerHTML = `
              <span class="price price--highlight">
                <span class="price__installment__number">10x de:</span>
                <span class="price__currency">
                  <span class="visually-hidden">Preço promocional</span>${window.TT._helpers.formatMoney(
                    (variant_info.price * 100) / 10
                  )}</span>
              </span>
              <span class="price price--alternative">
                <span>ou</span>
                <span class="price__currency">
                  <span class="visually-hidden">Preço promocional</span>${window.TT._helpers.formatMoney(
                    (variant_info.price * window.TT.general_infos.discount_factor)*100
                  )}</span>
                <span>à vista</span>
              </span>
              `;
            });
          }
        };
        let updateVariantRetailPriceComparison = () => {
          let elements = "[data-product-retail-price-comparison]";
          let retail_price = window.theme.product_infos.retail_price;
          let variant_info = selected_variant.price;
          if (retail_price) {
            let price_comparison = (1 - variant_info / retail_price) * 100;
            document.querySelectorAll(elements).forEach((el) => {
              el.innerHTML = `${price_comparison.toFixed(0)}% less vs. new`;
            });
          }
        };
        let updateVariantImages = async () => {
          let $media_slider = document.querySelector("[data-product-media]")
          let $variant_selected = selected_variant;
          if (!$variant_selected) {
            return;
          }
          let $variant_selected_details = window.theme.product_infos.product_variants.find(v=>v.id === $variant_selected.id)
          let $variant_images = $variant_selected_details?.variant_images
          let $current_variant_images = $media_slider.querySelectorAll('[data-product-variant-image]')
          let $current_variant_images_controls = $media_slider.querySelectorAll('[data-product-variant-image-control]')
          if ($current_variant_images) {
            window.TT._helpers.triggerEvent(
              "gallery:select-slide",
              $media_slider.querySelector('[data-original-position="0"]')
            );
            $current_variant_images.forEach((variant_image) => {
              window.TT._helpers.triggerEvent(
                "gallery:remove-slide",
                variant_image
              );
            })
          }
          if ($current_variant_images_controls) {
            $current_variant_images_controls.forEach(variant_image_control => {
              window.TT._helpers.triggerEvent(
                "gallery:remove-slide-control",
                variant_image_control
              );
            })
            setTimeout(() => {
              ()=>{return}
            }, 250);
          }
          if ($variant_images) {
            let _galleryEnabled = !!document.querySelector('.product__media-list.flickity-enabled');
            $variant_images.forEach((img, i) => {
              let variant_images_slide = null
              let variant_images_slide_control = null
              let toHTML = (htmlString) => {
                var div = document.createElement('div');
                div.innerHTML = htmlString.trim();

                // Change this to div.childNodes to support multiple top-level nodes.
                return div.firstChild;
              }
              let $timestamp = +Date.now()
              variant_images_slide =  `
                <div id="product-template--${window.theme.product_infos.product_id}__main-${$variant_selected.id}_${$timestamp}_${i}" class="product__media-item product__variant-image" data-product-variant-image data-media-type="image">
                  <div class="product__media-image-wrapper aspect-ratio aspect-ratio--natural"
                    style="padding-bottom: 100.0%; --aspect-ratio: 1.0">
                    <img loading="lazy" sizes="(max-width: 999px) calc(100vw - 48px), 640px" height="1500" width="1500"
                      alt="Comprar MacBook Pro usado - Troca Tech"
                      src="${img}">
                  </div>
                </div>
              `;
              variant_images_slide_control =  `
              <button type="button" tabindex="-1" reveal="" class="product__thumbnail-item product__variant-image__control hidden-pocket" data-product-variant-image-control aria-current="true"
                  aria-controls="product-template--${window.theme.product_infos.product_id}__main-${$variant_selected.id}_${$timestamp}_${i}" data-media-id="${$variant_selected.id}"
                  data-action="select" style="opacity: 1;">
                  <div class="product__thumbnail">
                    <img loading="lazy" sizes="(max-width: 999px) 72px, 60px" height="1500" width="1500"
                      alt="Comprar MacBook Pro usado - Troca Tech"
                      src="${img}">
                  </div>
                </button>
              `;
              window.TT._helpers.triggerEvent(
                "gallery:include-slide",
                toHTML(variant_images_slide)
              );
              window.TT._helpers.triggerEvent(
                "gallery:include-slide-control",
                toHTML(variant_images_slide_control)
              );
            });
            if(!_galleryEnabled){
              let $gallery = document.querySelector('flickity-carousel')
              await $gallery._createFlickity();
              $gallery.select(1)
            }
            setTimeout(() => {
              window.TT._helpers.triggerEvent(
                "gallery:select-slide",
                $media_slider.querySelector('[data-product-variant-image]')
              );
            }, 250);
          }
        };
        let updateVariantItemsIncluded = () => {
          let elements = "[data-product-items-included]";
          let variant_info = selected_variant;
          if (!variant_info) {
            return;
          }
          let default_included_items = ["Energias positivas"];
          let included_items_object = variant_info.metafields.find(
            (m) => m.key === "included_items"
          );
          let included_items = included_items_object
            ? JSON.parse(included_items_object.value)
            : [];
          included_items = default_included_items.concat(included_items);
          if (variant_info) {
            document.querySelectorAll(elements).forEach((el) => {
              el.innerHTML = `
                ${included_items
                  .map((item) => {
                    return `
                    <li class="product-form__items-included__item">
                      <div class="product-form__items-included__button">
                        <span class="product-form__items-included__title">
                          ${item}
                        </span>
                      </div>
                    </li>
                    `;
                  })
                  .join("")}
              `;
            });
          }
        };
        let updateVariantItemNonIncluded = () => {
          let elements = "[data-product-items-non-included]";
          let variant_info = selected_variant;
          if (!variant_info) {
            return;
          }
          let default_non_included_items = [];
          let non_included_items_object = variant_info.metafields.find(
            (m) => m.key === "non_included_items"
          );
          let non_included_items = non_included_items_object
            ? JSON.parse(non_included_items_object.value)
            : [];
          non_included_items =
            default_non_included_items.concat(non_included_items);
          if (variant_info) {
            document.querySelectorAll(elements).forEach((el) => {
              el.innerHTML = `
                ${non_included_items
                  .map((item) => {
                    return `
                    <li class="modal__accordion__item">
                      <div class="modal__accordion__button">
                        <span class="modal__accordion__title">
                          ${item}
                        </span>
                      </div>
                    </li>
                    `;
                  })
                  .join("")}
              `;
            });
          }
        };
        let updateCertifiedPhotosGallery = () => {
          let $gallery = document.querySelectorAll("[data-variant-certified-photos]")
          let $variant_selected = selected_variant;
          if (!$variant_selected) {
            $gallery.forEach(gallery => {
              _hidePhotoGallery(gallery)
            })
            return;
          }
          let $variant_selected_details = window.theme.product_infos.product_variants.find(v=>v.id === $variant_selected.id)
          let $variant_images = $variant_selected_details?.variant_images

          let _showPhotoGallery = (galleryElement) => {
            galleryElement.parentElement.classList.remove('hidden')
          }
          let _hidePhotoGallery = (galleryElement) => {
            galleryElement.parentElement.classList.add('hidden')
          }
          let _buildPhotoGallery = (galleryElement) => {
            let certifiedPhotosGalleryContent = $variant_images.map((img, i) => {
              return `
              <li class="product-form__certified-photos__item">
                <a href="${img}" class="product-form__certified-photos__image" data-pswp-width="1200" data-pswp-height="1200">
                  <img src="${img}" alt="" />
                </a>
              </li>
              `;
            })
            .join("");
            galleryElement.innerHTML = certifiedPhotosGalleryContent;
            let $lightbox = new PhotoSwipeLightbox({
              gallery: galleryElement,
              children: 'li',
              mainClass: 'pswp--custom',
              // dynamic import is not supported in UMD version
              pswpModule: PhotoSwipe
            });
            $lightbox.init();
          }
          if ($variant_images.length) {
            $gallery.forEach(gallery => {
              _buildPhotoGallery(gallery);
              _showPhotoGallery(gallery)
              gallery.parentElement.classList.remove('hidden')
            })
          } else {
            $gallery.forEach(gallery => {
              _hidePhotoGallery(gallery)
            })
          }
        };
        updateVariantMetafieldInfo(
          "color",
          '.product-meta__feature[data-feature="color"], #modal--technical_specifications [data-feature="color"], .section.product-seo [data-feature="color"]'
        );
        updateVariantMetafieldInfo(
          "storage",
          '.product-meta__feature[data-feature="storage"], #modal--technical_specifications [data-feature="storage"], .section.product-seo [data-feature="storage"]'
        );
        updateVariantPrice();
        updateVariantRetailPriceComparison();
        updateVariantItemsIncluded();
        updateVariantItemNonIncluded();
        updateVariantImages();
        updateCertifiedPhotosGallery();
        // variant_selector.selected_variant:updated
      }
    );
    document.addEventListener(
      "tt.gallery:include-slide",
      (e) => {
        let $slide = e.detail
        let $productMedia = document.querySelector('.product__media-list');
        let _galleryEnabled = !!document.querySelector('.product__media-list.flickity-enabled');
        let _includeSlide = async (slide, _index) => {
          const galleryInstance = document.querySelector('.product__media-list');
          if (galleryInstance && slide) {
            galleryInstance.appendChild(slide)
          }
        }
        let _removeSlide = async (slide) => {
          const galleryInstance = document.querySelector('.product__media-list');
          if (galleryInstance && slide) {
            galleryInstance.removeChild(slide)
          }
        }
        if(!_galleryEnabled){
          _includeSlide($slide,0);
        }
      }
    )
  }
  findVariantByParams(variant_params = this._store.selected_variant_params) {
    let product_variants = this._store.product_details.variants;
    let $variant_params = variant_params
    Object.keys($variant_params).forEach(key => $variant_params[key] === undefined && delete $variant_params[key])

    let filteredVariants = product_variants.find((variant) => {
      return Object.keys($variant_params).every(
        (key) => variant.details[key] === $variant_params[key]
      );
    });

    // console.log(`filteredVariants`, filteredVariants);

    return filteredVariants;
  }
  filterVariantsByParams(variant_params = this._store.selected_variant_params) {
    let product_variants = this._store.product_details.variants;

    let filteredVariants = product_variants.filter((variant) => {
      return Object.keys(variant_params).every(
        (key) => variant.details[key] === variant_params[key]
      );
    });
    if (filteredVariants.length === 1) {
    }

    console.log(`filteredVariants`, filteredVariants);

    return filteredVariants;
  }
  getAlternativeParams(variant_params = this._store.selected_variant_params) {
    let variant_parameters = this._store.product_details.variant_parameters;
    let current_variant_parameters = { ...variant_params };
    Object.keys(current_variant_parameters).forEach(key => current_variant_parameters[key] === undefined && delete current_variant_parameters[key])

    let product_variants = this._store.product_details.variants;

    let alternativeParams = Object.keys(variant_parameters)
      .map((param_key) => {
        let current_param_key = param_key;
        let current_param_value = current_variant_parameters[param_key];
        let alternative_param_values = variant_parameters[
          current_param_key
        ].filter((param) => param);
        // let alternative_param_values = variant_parameters[current_param_key].filter(param => param !== current_param_value)
        let alternative_params_search_result = alternative_param_values.map(
          (alt_param) => {
            let query = { ...current_variant_parameters };
            query[current_param_key] = alt_param;

            let query_result = this.findVariantByParams(query);

            let alt_param_search_result = {};

            alt_param_search_result["key"] = current_param_key;
            alt_param_search_result["value"] = alt_param;
            alt_param_search_result["query"] = query;
            alt_param_search_result["result"] = query_result;
            alt_param_search_result["available"] = !!query_result;

            return alt_param_search_result;
          }
        );

        return alternative_params_search_result;
      })
      .flat();

    // console.log(alternativeParams);
    return alternativeParams;
  }
  selectVariant (variant){
    if(!variant){
      return
    }
    document
      .querySelectorAll("[data-variant-selector-form]")
      .forEach(async (form) => {
        Object.keys(variant.details).forEach(param => {
          if (!["condition"].includes(param)) {
            return;
          }
          form.querySelector(`[data-variant-param-input="${param}"][data-variant-param-input-option="${variant.details[param]}"]`).checked = true
        })

        await window.TT._helpers.sleep(50);

        var event = new Event('change');
        form.dispatchEvent(event);

        await window.TT._helpers.sleep(50);

        Object.keys(variant.details).forEach(param => {
          if (!["condition", "color", "storage"].includes(param)) {
            return;
          }
          form.querySelector(`[data-variant-param-input="${param}"][data-variant-param-input-option="${variant.details[param]}"]`).checked = true
        })

        var event = new Event('change');
        form.dispatchEvent(event);

        await window.TT._helpers.sleep(50);

        var event = new Event('change');
        form.dispatchEvent(event);
      })
  }
  _setEvents() {
    document.addEventListener(
      `tt.variant_selector.get_product_details:success`,
      (e) => {
        let product_details = e.detail;
        this._store.product_details = product_details;
        this.buildVariantSelector();
        this.setVariantSelectorEvents();
      }
    );
    document.addEventListener(
      "tt.variant_selector:created", () => {
        let variants_sorted_by_price = this._store.product_details.variants
        let first_variant = variants_sorted_by_price[0]
        this.selectVariant(first_variant)
      }
    )
  }
  _init() {
    this._setEvents();
    this.getProductDetails();
  }
}
class ProductPage {
  constructor() {
    this.product_infos = window.theme.product_infos;
    this.related_products = document.querySelectorAll("product-item");
    this.related_collections = document.querySelectorAll(
      "collection-list .list-collections__item--overlay, collection-list .list-collections__item"
    );
    this.product_accordions = null;
    this.variant_selector = null;
    this.accordion_selectors = document.querySelectorAll("[data-accordion]");
    this.modal_triggers = document.querySelectorAll("[data-aside-modal]");
    this.technical_specifications_triggers = document.querySelectorAll(
      "[data-product-technical-specifications]"
    );
    this.product_add_forms = document.querySelectorAll(`[action="/cart/add"][data-product-id="${this.product_infos.product_id}"]`);
    this.product_add_buttons = document.querySelectorAll(`[data-product-add-to-cart-button="${this.product_infos.product_id}"]`);
    this._init();
  }
  _setEvents() {
    let $this = this;
    /* this.product_add_buttons.forEach((button) => {
      button.addEventListener('click', (e)=>{
        e.preventDefault();
        e.stopPropagation();
        return window.TT._helpers.triggerEvent(
          "product_form:add_to_cart",
          {},
          [...document.querySelectorAll(`[is="product-form"][data-product-id="${this.product_infos.product_id}"]`)].find(form => form.getAttribute('data-product-id') === this.product_infos.product_id)
        );
      })
    }) */
    this.related_products.forEach((product) => {
      product.addEventListener("click", (e) => {
        if (window.gtag) {
          gtag("event", "product_to_related_product", {
            availability: this.product_infos.availability,
            from: document
              .querySelector(".product[data-handle]")
              .getAttribute("data-handle"),
            to: e.currentTarget.getAttribute("data-handle"),
          });
        }
      });
    });
    this.related_collections.forEach((collection) => {
      collection.addEventListener("click", (e) => {
        if (window.gtag) {
          gtag("event", "product_to_collection", {
            availability: this.product_infos.availability,
            from: document
              .querySelector(".product[data-handle]")
              .getAttribute("data-handle"),
            to: e.currentTarget.getAttribute("data-handle"),
          });
        }
      });
    });
    document.addEventListener(
      "tt.variant_selector:created", () => {
        let variant_selector_modals = document.querySelectorAll('product-variant_selector-metafield [data-aside-modal]');
        variant_selector_modals.forEach((modal) => {
          let modal_id = `modal--${modal.getAttribute("data-aside-modal")}`;
          new Modal(modal_id);
          modal.addEventListener("click", (e) => {
            MicroModal.show(modal_id);
          });
        });
      }
    )
    document.addEventListener(
      "tt.variant_selector.selected_variant:updated",
      (e) => {
        let _this = $this;
        let $variant = e.detail;
        _this.product_add_forms.forEach(form => {
          form.querySelector('[name="id"]').value = $variant.id
        })
      })
  }
  _initProductShippingRates() {
    document.querySelectorAll('[data-get-product-shipping-rates-form]').forEach(shippingForm => {
      let $zipCodeInput = shippingForm.querySelector('[data-shipping-form-zipcode]');
      let $getShippingsBtn = shippingForm.querySelector('[data-shipping-form-get]');
      let $shippingResult = shippingForm.querySelector('[data-shipping-form-result]');
      let maskOptions = {
        mask: '00000-000'
      };
      IMask($zipCodeInput, maskOptions);
      $getShippingsBtn.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          var zipcode = $zipCodeInput.value.replace(/[\.\-]/g, '');
          if (zipcode.length < 8) {
                $shippingResult.innerHTML = "Ops, CEP inválido.";
                document.querySelector('.product-form__shipping-calculation__result').removeAttribute('hidden')
          } else {
                /* let $cart = await EvolveCore.Cart.fetch() */
                if ($cart?.items?.length === 0) {
                  await this._addTestProductToCalculateShipping()
                }
                await window.TT._helpers.sleep(500);
                let shipping_rates = await this._getShippingRates(zipcode);
                let delivery_dates = shipping_rates.map((rate)=>{
                  return rate.delivery_date
                }).sort(function(a,b){
                  return new Date(a) - new Date(b);
                });
                $shippingResult.innerHTML = `Entrega de <b>${dayjs(delivery_dates.shift()).format('DD/MM')} a ${dayjs(delivery_dates.pop()).format('DD/MM')}</b>`
                document.querySelector('.product-form__shipping-calculation__form').setAttribute('hidden', true)
                document.querySelector('.product-form__shipping-calculation__result').removeAttribute('hidden')

                if ($cart?.items?.length > 0) {
                  await this._clearTestProductToCalculateShipping();
                }
            }
        })
      })
  }
  async _getShippingRates(cep) {
    try {
      let $shipping_rates = null
      await axios.post("/cart/prepare_shipping_rates.json?shipping_address[zip]=" + cep + "&shipping_address[country]=Brazil&shipping_address[province]=S%C3%A3o%20Paulo")
      await window.TT._helpers.sleep(1000);
      $shipping_rates = await axios.get("/cart/async_shipping_rates.json?shipping_address[zip]=" + cep + "&shipping_address[country]=Brazil&shipping_address[province]=S%C3%A3o%20Paulo")
      if(!$shipping_rates?.data?.shipping_rates){
        await window.TT._helpers.sleep(1000);
        $shipping_rates = await axios.get("/cart/async_shipping_rates.json?shipping_address[zip]=" + cep + "&shipping_address[country]=Brazil&shipping_address[province]=S%C3%A3o%20Paulo")
      }
      if(!$shipping_rates?.data?.shipping_rates){
        await window.TT._helpers.sleep(1000);
        $shipping_rates = await axios.get("/cart/async_shipping_rates.json?shipping_address[zip]=" + cep + "&shipping_address[country]=Brazil&shipping_address[province]=S%C3%A3o%20Paulo")
      }
      return $shipping_rates.data.shipping_rates
    } catch (error) {
      throw new Error(error.message)
    }
  }
  async _addTestProductToCalculateShipping() {
    await axios.post('/cart/add.js', {
        quantity: 1,
        id: theme.product_infos.product_variants[0].id,
        properties: {
          '_shipping': 'test'
        }
    })
    return true
  }
  async _clearTestProductToCalculateShipping(callback) {
    await axios.post('/cart/clear.js', {})
    return true
  }
  _initVariantSelector() {
    this.variant_selector = new VariantSeletorByMetafields(
      this.product_infos.product_handle
    );
  }
  _initProductAccordions() {
    this.accordion_selectors.forEach((accordion) => {
      new Accordion(accordion);
    });
  }
  _initProductModals() {
    this.modal_triggers.forEach((modal) => {
      let modal_id = `modal--${modal.getAttribute("data-aside-modal")}`;
      new Modal(modal_id);
      modal.addEventListener("click", (e) => {
        MicroModal.show(modal_id); // [1]
        // MicroModal.close('modal-id'); // [2]
      });
    });
  }
  _initProductTechnicalSpecifications() {
    if(!window?.theme?.product_infos?.technical_specifications){
      return
    }
    this.technical_specifications_triggers.forEach((spec_list) => {
      let technical_specifications = Object.keys(
        window.theme.product_infos.technical_specifications
      )
        .map((spec) => {
          let value = window.theme.product_infos.technical_specifications[spec];
          if (typeof value === "boolean") {
            value = value ? "Sim" : "Não";
          }

          return `
            <li class="stacked-list__item">
                <div class="stacked-list__button">
                <span class="stacked-list__title">
                    ${window.theme.product_infos._translations.product_technical_specifications[spec]}
                </span>
                <span class="stacked-list__content" data-feature="${spec}">
                    ${value}
                </span>
                </div>
            </li>
        `;
        })
        .join("");
      spec_list.innerHTML = technical_specifications;
    });
  }
  _init() {
    this._setEvents();
    this._initVariantSelector();
    this._initProductModals();
    this._initProductAccordions();
    this._initProductTechnicalSpecifications();
    this._initProductShippingRates();
  }
}

class TT_Core {
  constructor() {
    this.general_infos = {
      discount_rate: 5
    }
    this.general_infos.discount_factor = (100 - this.general_infos.discount_rate)/100

    if (isPage("t-collection")) {
      this.collection_page = new CollectionPage();
    }
    if (isPage("t-product")) {
      this.product_page = new ProductPage();
    }
    this._helpers = {
      sleep: (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      formatMoney: (cents, format = "R$ {{amount_with_comma_separator}}") => {
        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || window.themeVariables.settings.moneyFormat;
        function defaultTo(value2, defaultValue) {
          return value2 == null || value2 !== value2 ? defaultValue : value2;
        }
        function formatWithDelimiters(number, precision, thousands, decimal) {
          precision = defaultTo(precision, 2);
          thousands = defaultTo(thousands, ",");
          decimal = defaultTo(decimal, ".");
          if (isNaN(number) || number == null) {
            return 0;
          }
          number = (number / 100).toFixed(precision);
          let parts = number.split("."),
            dollarsAmount = parts[0].replace(
              /(\d)(?=(\d\d\d)+(?!\d))/g,
              "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
          return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
          return formatString.replace(placeholderRegex, value);
        } else {
          return formatString.replace(placeholderRegex, value);
        }
      },
      scrollTo: ($selector) => {
        $selector.scrollIntoView({
          behavior: "smooth",
        });
      },
      triggerEvent: (name, payload, element) => {
        var event = new CustomEvent(`tt.${name}`, {
          bubbles: true,
          detail: payload ? payload : null,
        });
        if(element){
          return element.dispatchEvent(event);
        }
        document.dispatchEvent(event);
      },
      groupBy: (obj_array, prop) => {
        if (!obj_array) {
          throw new Error("Object is required");
        }
        if (!prop) {
          return obj_array;
        }
        return obj_array.reduce(function (r, a) {
          let $key = a[prop];
          r[$key] = r[$key] || [];
          r[$key].push(a);
          return r;
        }, Object.create(null));
      },
      docReady: function (callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") {
          // do async to allow for other scripts to run. metafizzy/flickity#441
          setTimeout(callback);
        } else {
          document.addEventListener("DOMContentLoaded", callback);
        }
      },
    };
  }
}

/* var $cartNotification =
  window.$cartNotification || document.querySelector("cart-drawer");
$cartNotification.remove();
$cartNotification.show = false;
$cartNotification.open = false;
$cartNotification.close = false; */

window.docReady(() => {
  setTimeout(() => {
    window.TT = window.TT || new TT_Core();
  }, 1000);
});

const loadCustomInstallment = () => {
  const installmentScripts = document.querySelectorAll('[data-script-content]');
  if(installmentScripts.length > 0){
      installmentScripts.forEach((item, idx) => {
          const functionName = item.getAttribute('data-script-content');
          const hasScript = document.querySelector([`[data-custom-function="${functionName}"]`]);
          if(!hasScript){
              const scriptContent = item.textContent;
              const newScript = document.createElement('script');
              newScript.setAttribute('data-custom-function', functionName);
              newScript.textContent = scriptContent;
              document.body.appendChild(newScript);
          }
      })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  loadCustomInstallment();

  const targetNode = document.getElementById('facet-main');
    if(targetNode){
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                loadCustomInstallment();
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});